import { render, staticRenderFns } from "./employeeTable.vue?vue&type=template&id=54835ed2&scoped=true&"
import script from "./employeeTable.vue?vue&type=script&lang=js&"
export * from "./employeeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54835ed2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54835ed2')) {
      api.createRecord('54835ed2', component.options)
    } else {
      api.reload('54835ed2', component.options)
    }
    module.hot.accept("./employeeTable.vue?vue&type=template&id=54835ed2&scoped=true&", function () {
      api.rerender('54835ed2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/market/activeManage/detail/employeeTable.vue"
export default component.exports